import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "time-slot" }

import { TimeRange } from '@/types';
import { computed } from 'vue';

interface Props {
  time: TimeRange
  index: number
  shiftsLength: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VitaTimeSlot',
  props: {
    time: {},
    index: {},
    shiftsLength: {}
  },
  setup(__props: any) {

const props = __props

// Составные типы смен, для которых выводится сразу несколько лейблов
const compositeTypes: Record<string, string[]> = {
  MainProfi: ['Main', 'ProfiPst']
}

// Получение стилей и названия согласно типу и статусу
const timeSlotType = (type: string, big: boolean) => {
  const typeObj: Record<string, { name: string; classname: string; big: boolean }> = {
    Main: {
      name: 'Осн.',
      classname: 'main-style',
      big: false
    },
    Exchange: {
      name: 'Беру!',
      classname: 'exchange-style',
      big: false
    },
    Partner: {
      name: 'Нап.',
      classname: 'partner-style',
      big: false
    },
    ProfiPst: {
      name: 'ПСТ',
      classname: 'profi-pst-style',
      big: false
    }
  }

  const current = typeObj[type]

  // Для всех остальных типов возвращаем базовый объект
  if (!current) {
    return {
      name: type || '',
      classname: '',
      big
    }
  }

  if (big) {
    if (type === 'Main') {
      current.name = 'Основная'
    }
    if (type === 'Partner') {
      current.name = 'Напарник'
    }
    current.big = true
  }

  return current
}

// У составных типов лейбл не растягиваем
const isBigLabel = computed(() => props.time.big && !compositeTypes[props.time.type])

// Лейблы смены: у составных типов их несколько
const timeSlotLabels = computed(() => {
  const types = compositeTypes[props.time.type] || [props.time.type]

  return types.map(type => timeSlotType(type, isBigLabel.value))
})

// Не выводим слоты со статусами Canceled и MissAccepted
const isTimeSlotVisible = computed(() => {
  return props.time.status !== 'Canceled' && props.time.status !== 'MissAccepted'
})

return (_ctx: any,_cache: any) => {
  return (__props.time.zupGuid)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (isTimeSlotVisible.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["time-slot-wrap", {'time-slot': true, 'time-slot-big': __props.time.big, 'time-slot-passed': __props.time.passed}])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["time-slot-inner", {'time-slot-big-inner': isBigLabel.value}])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timeSlotLabels.value, (label, labelIndex) => {
                  return (_openBlock(), _createElementBlock("span", {
                    class: _normalizeClass(["time-slot-label", [label.classname, {'time-slot-label-split': timeSlotLabels.value.length > 1}]]),
                    key: labelIndex
                  }, _toDisplayString(label.name), 3))
                }), 128)),
                _createElementVNode("div", _hoisted_1, _toDisplayString(__props.time.timeFrom) + " - " + _toDisplayString(__props.time.timeTo), 1)
              ], 2)
            ], 2))
          : _createCommentVNode("", true)
      ], 64))
    : _createCommentVNode("", true)
}
}

})